(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-banner"] && !window.DesignMode) return;
  try {
    
    document.addEventListener( 'DOMContentLoaded', function() {
        var splide = new Splide('#product-banner', {
            perPage: 4,
            drag   : 'free',
            snap   : true,
            autoScroll: {
                speed: 1,
            },
            pagination: false,
        });
        splide.mount();
    } );

  } catch(e) { console.error(e); }
})();
})();
